/*
  Notification settings: what the e-mail switch controls. Merged FIRST into
  TRANSLATION_MAPS in ./index.js. Keys are the English source.
*/

const ru = {
  "Summaries of problems (rejected leads and postbacks, no clicks) also come by e-mail. Billing e-mails always arrive.": "Сводки о проблемах (отклонённые лиды и постбэки, нет кликов) приходят и письмом. Письма об оплате приходят всегда.",
};

const es = {
  "Summaries of problems (rejected leads and postbacks, no clicks) also come by e-mail. Billing e-mails always arrive.": "Los resúmenes de problemas (leads y postbacks rechazados, sin clics) también llegan por correo. Los correos de facturación llegan siempre.",
};

const pt = {
  "Summaries of problems (rejected leads and postbacks, no clicks) also come by e-mail. Billing e-mails always arrive.": "Os resumos de problemas (leads e postbacks rejeitados, sem cliques) também chegam por e-mail. Os e-mails de cobrança chegam sempre.",
};

const de = {
  "Summaries of problems (rejected leads and postbacks, no clicks) also come by e-mail. Billing e-mails always arrive.": "Zusammenfassungen von Problemen (abgelehnte Leads und Postbacks, keine Klicks) kommen auch per E-Mail. E-Mails zur Abrechnung kommen immer.",
};

const fr = {
  "Summaries of problems (rejected leads and postbacks, no clicks) also come by e-mail. Billing e-mails always arrive.": "Les résumés de problèmes (leads et postbacks refusés, aucun clic) arrivent aussi par e-mail. Les e-mails de facturation arrivent toujours.",
};

const it = {
  "Summaries of problems (rejected leads and postbacks, no clicks) also come by e-mail. Billing e-mails always arrive.": "I riepiloghi dei problemi (lead e postback rifiutati, nessun clic) arrivano anche via email. Le email di fatturazione arrivano sempre.",
};

const pl = {
  "Summaries of problems (rejected leads and postbacks, no clicks) also come by e-mail. Billing e-mails always arrive.": "Podsumowania problemów (odrzucone leady i postbacki, brak kliknięć) przychodzą też e-mailem. E-maile o płatnościach przychodzą zawsze.",
};

const tr = {
  "Summaries of problems (rejected leads and postbacks, no clicks) also come by e-mail. Billing e-mails always arrive.": "Sorun özetleri (reddedilen lead’ler ve postback’ler, tıklama yok) e-postayla da gelir. Faturalandırma e-postaları her zaman gelir.",
};

const uk = {
  "Summaries of problems (rejected leads and postbacks, no clicks) also come by e-mail. Billing e-mails always arrive.": "Зведення про проблеми (відхилені ліди й постбеки, немає кліків) приходять і листом. Листи про оплату приходять завжди.",
};

const NOTIFICATION_CHANNELS = { ru, es, pt, de, fr, it, pl, tr, uk };
export default NOTIFICATION_CHANNELS;
